import React from 'react';
import Reveal from './Reveal';
import { ArrowIcon } from './icons';
import { ALCOR_SWAP, CLOUD_WALLET, ANCHOR_GUIDE, WAXP_GUIDE } from '../data';
import logo from '../../public/smartpepe.webp';
import '../styles/howtobuy.css';

const STEPS = [
  {
    n: '01',
    title: 'Create a wallet',
    body: (
      <>
        Spin up a free <a href={CLOUD_WALLET} target="_blank" rel="noopener noreferrer">WAX Cloud Wallet</a> in
        seconds — or go self-custody with <a href={ANCHOR_GUIDE} target="_blank" rel="noopener noreferrer">Anchor</a>.
      </>
    ),
  },
  {
    n: '02',
    title: 'Get some WAXP',
    body: (
      <>
        Grab <a href={WAXP_GUIDE} target="_blank" rel="noopener noreferrer">WAXP</a> from a major exchange
        like Binance, KuCoin, OKX or Bybit and send it to your wallet.
      </>
    ),
  },
  {
    n: '03',
    title: 'Swap for $KEK',
    body: (
      <>
        Swap WAXP → $KEK on Alcor. Buying in is
        presented as fee-free in the interface, but this token is for entertainment only
        and selling may be subject to transfer mechanics.
      </>
    ),
  },
];

const HowToBuy = () => (
  <section className="section how" id="how-to-buy">
    <Reveal className="how-head">
      <span className="eyebrow">how to buy</span>
      <h2 className="section-title">grab a bag in <span className="accent">three steps</span></h2>
      <p className="section-lead">New to WAX? You can get $KEK in under five minutes.</p>
    </Reveal>

    <div className="how-grid">
      <ol className="how-steps">
        {STEPS.map((s, i) => (
          <Reveal as="li" className="how-step glass" key={s.n} delay={i * 0.1}>
            <span className="how-step-n">{s.n}</span>
            <div className="how-step-body">
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          </Reveal>
        ))}
      </ol>

      <Reveal className="how-swap glass" id="swap-widget" delay={0.15}>
        <img className="how-swap-logo" src={logo} alt="" aria-hidden="true" />
        <h3 className="how-swap-title">Swap WAXP → $KEK</h3>
        <p className="how-swap-sub">Trade on Alcor DEX. External venue — review its rules and your local laws before using it.</p>
        <a className="btn btn-primary how-swap-cta" href={ALCOR_SWAP} target="_blank" rel="noopener noreferrer">
          Swap on Alcor <ArrowIcon />
        </a>
        <span className="how-swap-note">opens alcor.exchange in a new tab</span>
      </Reveal>
    </div>
  </section>
);

export default HowToBuy;
